import { TextCaption } from '../text/Texts';
import { cn } from '../ui/cn';
import styles from './coming-soon-badge.module.css';

type Props = {
	text?: string;
	className?: string;
};

const ComingSoonBadge = ({ text = 'Coming soon', className }: Props) => {
	return (
		<span className={cn(styles.badge, className)}>
			<TextCaption text={text} className={styles.badgeText} />
		</span>
	);
};

export default ComingSoonBadge;
